import { Tab, TabSelectCard } from 'src/components/TabSelectCard';

import { MerchantInformation, OutletInformation } from './components/Sections';
import { BusinessInformation } from './components/Sections/BusinessInformation';
import { PrincipalInformation } from './components/Sections/PrincipalInformation';
import ServiceRequirementsInformation from './components/Sections/ServiceRequirementsInformation';

const TABS: Tab[] = [
    { header: 'Select Partner', children: <PrincipalInformation /> },
    {
        header: 'Service Requirements',
        children: <ServiceRequirementsInformation />,
    },
    { header: 'Merchant Information', children: <MerchantInformation /> },
    { header: 'Outlet Information', children: <OutletInformation /> },
    { header: 'Business Information', children: <BusinessInformation /> },
];

const InformationSection: React.FC = () => {
    return (
        <TabSelectCard
            tabs={TABS}
            headerStyles={{ fontSize: '14px', lineHeight: '20px', fontWeight: 400 }}
        />
    );
};
export default InformationSection;
